import { RouterType } from '@online-webinar/router';
import { WebinarContent } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/content'].update({
        staticData: { title: { page: 'Title.Content', forWebinar: true } },
        component: authGuard(WebinarContent, { canBroadcast: true })
    });
};
